import React, { useEffect, useState } from 'react';
import UserIcon from "../../../../Assets/Account/NameIcon.svg";
import EmailIcon from "../../../../Assets/Account/EmailIcon.svg";
import DocumentIcon from "../../../../Assets/Account/Detail.svg";
import { getBusinessInfo } from '../../../../lib/utils/apiCalls';

function SectionBox({ icon, title, value, border }) {
    return (
        <div className={`p-[10px] flex items-center gap-3 ${border && 'border-b border-[#EAEAEA]'}`}>
            <div className="size-6 flex items-center justify-center">
                <img src={icon} alt="" />
            </div>

            <div className="flex flex-col gap-1 font-medium">
                <h1 className='text-[14px] leading-5 text-[#808080]'>{title}</h1>

                <p className='text-[16px] leading-5 text-[#000000]'>{value}</p>
            </div>
        </div>
    )
}

function BusinessInfo() {
    const [businessInfo, setBusinessInfo] = useState({});

    async function fetchBusinessInfo() {
        try {
            const response = await getBusinessInfo();
            if(response.status === 200) {
                setBusinessInfo(response.data.data.seller);
            }
        }
        catch(err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchBusinessInfo();
    }, []);

    return (
        <div className='w-3/5 flex flex-col gap-4'>
            <div className="flex flex-col gap-4">
                <h1 className='font-semibold text-[20px] leading-6 text-[#121212]'>Business Info</h1>

                <div className="flex flex-col gap-4 p-4 shadow-[0_0_6px_0_#0000001F] rounded-xl">
                    <SectionBox 
                        icon={UserIcon} 
                        title={'Owner Name'} 
                        value={businessInfo.ownerName} 
                        border 
                    />

                    <SectionBox 
                        icon={EmailIcon} 
                        title={'Owner Email Id'} 
                        value={businessInfo.ownerEmail} 
                        border 
                    />

                    <SectionBox 
                        icon={DocumentIcon} 
                        title={'Gstin Number'} 
                        value={businessInfo.gstIn} 
                        border 
                    />

                    <SectionBox 
                        icon={DocumentIcon} 
                        title={'PAN Number'} 
                        value={businessInfo.panNo} 
                    />
                </div>
            </div>
        </div>
    );
}

export default BusinessInfo;
